import axios from 'axios';

const isProduction = import.meta.env.PROD;
const baseURL = isProduction 
  ? 'https://navsan-timesheet-api-b5d6cdcfe5dre4c8.centralus-01.azurewebsites.net'
  : import.meta.env.VITE_API_URL;

console.log('Environment:', isProduction ? 'production' : 'development');
console.log('Base URL:', baseURL);

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Origin': 'https://timesheet.navsan.com'
  },
  withCredentials: false,
  // Don't follow redirects automatically to catch HTTPS->HTTP redirects
  maxRedirects: 0
});

axiosInstance.interceptors.request.use(
  config => {
    // Log request details for debugging
    console.log('Request:', {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      headers: config.headers
    });
    
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Ensure proper headers for OPTIONS requests
    if (config.method?.toLowerCase() === 'options') {
      config.headers['Access-Control-Request-Method'] = 'POST';
      config.headers['Access-Control-Request-Headers'] = 'content-type,authorization';
    }
    
    return config;
  },
  error => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    // Handle redirects
    if (error.response?.status >= 300 && error.response?.status < 400) {
      const location = error.response.headers.location;
      console.error('Redirect detected:', {
        status: error.response.status,
        location: location,
        originalUrl: error.config.url
      });
      
      // If redirect is from HTTPS to HTTP, reject it
      if (location && location.startsWith('http://')) {
        console.error('HTTPS to HTTP redirect blocked for security');
        error.message = 'HTTPS to HTTP redirect blocked. Please check API configuration.';
      }
    }
    
    if (error.response?.status === 405) {
      console.error('Method not allowed. URL:', error.config.url);
      console.error('Method:', error.config.method);
      console.error('Headers:', error.config.headers);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
